export type GnomePreloadMode = "off" | "bytes" | "prepare";

export function allowsGnomeBackgroundWork(input: {
    visible: boolean;
    online: boolean;
    saveData?: boolean;
    effectiveType?: string;
}): boolean {
    return (
        input.visible &&
        input.online &&
        input.saveData !== true &&
        input.effectiveType !== "slow-2g" &&
        input.effectiveType !== "2g"
    );
}

export function browserGnomeBackgroundAllowed(): boolean {
    const connection =
        "connection" in navigator ? navigator.connection : undefined;
    const hints =
        typeof connection === "object" && connection !== null ? connection : {};
    return allowsGnomeBackgroundWork({
        visible: document.visibilityState === "visible",
        online: navigator.onLine !== false,
        saveData: "saveData" in hints && hints.saveData === true,
        effectiveType:
            "effectiveType" in hints && typeof hints.effectiveType === "string"
                ? hints.effectiveType
                : undefined,
    });
}
